import qs from 'qs';
import { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom-v5-compat';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import SessionClientOnboard from 'dashboard/lib/clients/SessionClientOnboard';
import useRedirectIfLoggedIn from 'dashboard/lib/hooks/useRedirectIfLoggedIn';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { OnboardingFlowV1 } from 'dashboard/models/onboarding-flow-v1';
import { showMessage } from 'dashboard/redux/actions/messages';
import { clearOnboardingFlow } from 'dashboard/redux/actions/onboarding-flow';
import { RootState } from 'dashboard/redux/store';
import { refreshSession } from 'dashboard/redux/thunk-actions/current-user-session';
import DashboardRegisterActivateView from 'dashboard/views/DashboardRegisterActivateView';
import ApiResponseError from 'lib/errors/ApiResponseError';
import { ApiModel } from 'lib/interfaces/api';

const DashboardRegisterActivateRoute = (props: PropsFromRedux) => {
  const location = useLocation();
  const {
    email: prefilledEmail,
    onboarding_flow_id: onboardingFlowId,
    activation_token: activationToken,
    country: onboardingFlowCountry,
  } = qs.parse(location.search, { ignoreQueryPrefix: true });

  useRedirectIfLoggedIn();

  const navigate = useNavigate();

  useEffect(() => {
    if (!SessionClientDashboard.isLoggedIn()) {
      (async () => {
        try {
          if (onboardingFlowCountry) {
            SessionClientOnboard.personaCountry = onboardingFlowCountry as string;
          }
          const activationResponse =
            await SessionClientOnboard.postResourceAction<OnboardingFlowV1>(
              {
                id: onboardingFlowId as string,
                type: ApiModel.OnboardingFlowV1,
                attributes: {
                  'email-address': prefilledEmail as string,
                  'activation-token': activationToken as string,
                },
              },
              'activate',
            );

          const refreshToken = activationResponse.meta?.['refresh-token'];

          if (!refreshToken) {
            throw new Error('No refresh token found in response');
          }

          try {
            await props.refreshSession(refreshToken);
          } catch (e) {
            navigate('/dashboard/login');
          }
          props.clearOnboardingFlow();

          navigate('/dashboard/home');
        } catch (err) {
          if (err instanceof ApiResponseError && err.status === 409) {
            props.showMessage(
              'Sorry, this email address is already taken. Please try with a different email.',
              MessageType.Failure,
            );
          } else {
            props.showMessage(
              'An error occurred. Please check if your link is expired, and try again.',
              MessageType.Failure,
            );
          }
        }
      })();
    }
  }, []);

  return <DashboardRegisterActivateView />;
};

const mapStateToProps = (_state: RootState) => {
  return {};
};

const mapDispatchToProps = {
  clearOnboardingFlow,
  refreshSession,
  showMessage,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DashboardRegisterActivateRoute);
